import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var CHECK_EMAIL = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query checkEmail($email: String!) {\n        checkEmail(email: $email) {\n            username\n        }\n    }\n"])));